import { Alert } from '@lifebit-ai/lds'
import React from 'react'

import { type FieldComponentProps, type InformationPanelFormField } from './fieldTypes'
import * as styles from './ViewFormModal.styles'

export const InformationPanelField = ({ field }: FieldComponentProps<InformationPanelFormField>) => {
  return (
    <styles.TextField>
      <Alert type="info" showIcon title={field.label}>
        {field.alertMessage}
      </Alert>
    </styles.TextField>
  )
}
